import { render } from "./MdAvatarLoader.vue?vue&type=template&id=9e648c74&scoped=true&ts=true"
import script from "./MdAvatarLoader.vue?vue&type=script&lang=ts"
export * from "./MdAvatarLoader.vue?vue&type=script&lang=ts"

import "./MdAvatarLoader.vue?vue&type=style&index=0&id=9e648c74&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e648c74"]])

export default __exports__